export default __webpack_public_path__ + "static/media/list.5a47a604.svg";